.previewBody {
  width: 100%;
}

.previewContent {
  flex: 1;
  min-width: 0;
  height: 75vh;
}

.previewImage {
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
}

.pdfFrame {
  width: 100%;
  height: 100%;
  border: 0;
}

.fallbackIcon {
  font-size: var(--ant-font-size-heading-1);
  color: var(--ant-color-text-secondary);
}

.navigationButton {
  flex-shrink: 0;
}

.fileName {
  min-width: 0;
}
